export const appendInlineScript = (id: string, scriptContent: string): void => {
  if (document.getElementById(id)) return;

  const script = document.createElement('script');
  script.id = id;
  script.textContent = scriptContent;
  document.head.appendChild(script);
};
